export default __webpack_public_path__ + "static/media/drag-point.e757629d.svg";